/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Select, MenuItem } from '@material-ui/core';

class ContraSourceSelect extends React.Component {
  render() {
    return (
      <Select
        required
        displayEmpty
        fullWidth
        value={this.props.value}
        onChange={this.props.onChange}
        inputProps={this.props.inputProps}
      >
        <MenuItem value="">
          <em>Blank</em>
        </MenuItem>
        <MenuItem value="frb">FRB</MenuItem>
        <MenuItem value="velox">Velox</MenuItem>
        <MenuItem value="vision">Vision</MenuItem>
        <MenuItem value="svb">SVB</MenuItem>
        <MenuItem value="bmo">BMO</MenuItem>
      </Select>
    );
  }
}

export default ContraSourceSelect;
